import { useEffect } from 'react';
import { settingsApi } from '../api/endpoints';
import { resolveSiteMedia } from '../utils/mediaUrl';
import { LOCAL_DEFAULTS } from '../constants/defaultAssets';

function upsertLink(rel, href, type = 'image/png') {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
  if (type) link.type = type;
}

/** Browser tab icon — same intro/brand logo as the site intro */
export default function SiteFavicon() {
  useEffect(() => {
    const apply = (href) => {
      const icon = href || LOCAL_DEFAULTS.introLogo;
      upsertLink('icon', icon);
      upsertLink('shortcut icon', icon);
      upsertLink('apple-touch-icon', icon, null);
    };

    apply(LOCAL_DEFAULTS.introLogo);

    settingsApi
      .get()
      .then((res) => {
        const s = res.data?.data;
        const href =
          resolveSiteMedia(s, 'introLogo') ||
          resolveSiteMedia(s, 'brandLogo') ||
          LOCAL_DEFAULTS.introLogo;
        apply(href);
      })
      .catch(() => {});
  }, []);

  return null;
}
